export default "__VITE_ASSET__6d79b845__"